import * as $ from 'jquery';
import 'bootstrap';
require('datatables.net');
require('datatablesResponsive');
import * as moment from 'moment';
import { bookingFormCommon } from './c005-bookingform-common';
import { adobeDataLayerWrapper } from "./adobeDataLayerMethod";
import { wcagOptions } from "./wcag";
import 'MagnificPopup';

export class flightStatusForm {
	private $flightStatusError:Array<any> = [];
	private wcag = new wcagOptions();
	private bcommon = new bookingFormCommon();

	$scope: any = $('#flight-status--container');
	$scopeMob: any = $('#mob-flightstatus--container');

	$statusCitiesContainer: any = $('.status-cities--container');
	$statusFlightnoContainer: any = $('.status-flightno--container');
	$statusCitiesErrorValidation: any = $('.status-cities--error---validation');
	$statusCitiesSubmitBtn: any = $('.statusCitiesSubmit');
	$statusFlightDate: any = $('.status-flight--date');
	$statusFromLocationSel: any = $('.status-from--location');
	$statusToLocationSel: any = $('.status-to--location');
	$statusCitiesValidator : any = $('.status-cities--validator');
	$statusFlightnoErrorValidation: any = $('.status-flightno--error---validation');
	$statusFlightnoSubmitBtn: any = $('.statusFlightNoSubmit');
	$statusFlightnoSel: any = $('.status-flightno--date');
	$statusFlightNo: any = $('.status-flight--no');
	$statusFlightnoValidator : any = $('.status-flightno--validator');

	// value for populating to to location field on from location update complete
	toPrepop:string = null;

	nav(): void {
		let _self = this;
		let bcommon = _self.bcommon;

		let $mabHeader:any  = $('#mab-header');
		let $mobIbeNav: any = $('#mab-bookingnav.mobile #bookingNav');

		let $bookFlight : any = $('#book-flight--container');
		let $checkIn    : any = $('#check-in--container');
		let $viewBooking: any = $('#view-booking--container');
		let $mhStay     : any = $('#ibe-stay--container');
		let $mhUpgrade  : any = $('#mhupgrade-in--container');
		let $login      : any = $('#login-container');
		let $loggedin   :any = $('#logged-in-user-menu');

		let $bookFlightMob : any = $('#mobile-bookflight--container');
		let $checkInMob    : any = $('#mob-checkin--container');
		let $viewBookingMob: any = $('#mob-viewbooking--container');
		let $mhStayMob     : any = $('#mob-stay--container');
		let $mhUpgradeMob  : any = $('#mob-mhupgrade--container');
		let $loginMob      : any = $('#mob-login--container');
		let $loggedinMob   : any = $('#mob-logged-in-user-menu');
		let $mobMholidays  : any = $('#mobile-mholidays--container');
		let $mhHolidays : any    = $('#mholiday-ibe--container');  
		let $flightUpgrade : any = $('#view-upgrade');
		let $flightupgradeMob: any 	 = $('#mob-flightupgrade--container');
		let $moreLinksMob: any 	 = $('#mob-more-links--container');

		let $ibeNav: any;
		if($('.ibe-refresh').length >0) {
			$ibeNav = $('.desktop #bookingNav');
		}
		else {
			$ibeNav = $('#bookingNav');
		}
		let $ibeNavList: any = $('#bookingNav li');
		let $navOverlay: any = $('.mab-nav--overlay');

		let $errorValidationGen      :any     = $('.status-cities--error---validation');
		let $errorValidationFlightGen:any     = $('.status-flightno--error---validation');
		let $bookingFormTitle        :any       = $('.booking-form--title');
		let $inputValidator          :any       = $('.form-validate input');
		let $selectizeInputGen       :any      = $('.selectize-control .selectize-input');

		let $statusFlightDateSel:any        =   $('.status-flight--date');
		let $statusFromLocSel:any           =   $('.status-from--location');
		let $statusToLocSel:any             =   $('.status-to--location');
		let $statusFlightNoDateSel:any      =   $('.status-flightno--date');
		let $statusFlightDateSelectize:any  =   $statusFlightDateSel.parent().find('.selectize-control .selectize-input');
		let $statusFromLocSelectize:any     =   $statusFromLocSel.parent().find('.selectize-control .selectize-input');
		let $statusToLocSelectize:any       =   $statusToLocSel.parent().find('.selectize-control .selectize-input');
		let $statusFlightNoDateSelectize:any  =   $statusFlightNoDateSel.parent().find('.selectize-control .selectize-input');
		let $moreLinks: any 	 = $('#more-links--container');
		let $moreLinksFlightStatus: any 	 = $('#more-links--container .flight-status');

		$('.MHdiv').hide();

		$(".status-flight--no").on( 'click, focus', () =>{
			$('.MHdiv').show();
		});	
		$(".status-flight--no").on( 'blur', (evt:any) =>{
			if(evt.target.value==''){
				$('.MHdiv').hide();
			}else{
				$('.MHdiv').show();
			}
		});	
		// IBE Navigation show/hide Check in container
		$ibeNav.find('.flight-status').on('click', () =>{
			adobeDataLayer.push('click', {
                'clickName': 'click:tab-click:top-nav-flight-status',
                'componentType': 'tab',
                'componentName': 'Flight Status Top Menu',
                'componentID': '',
				'attributes': []
            });
			$ibeNav.find('li').removeClass('selected');
			$ibeNav.find('.flight-status').parent().addClass('selected');
			if ($('.enrich-revamp').length > 0) {
				$('.enrich-revamp .enrich-header #mab-bookingnav .navbar-default').removeClass('mholidays-navbar');
			}
			_self.$scope.show();
			$bookFlight.hide();
			$flightUpgrade.hide();
			$checkIn.hide();
			$viewBooking.hide();
			$mhStay.hide();
			$mhUpgrade.hide();
			$login.hide();
			$moreLinks.hide();
			$mhHolidays.hide();
			$loggedin.addClass('hidden');
			_self.$scopeMob.show();
			$bookFlightMob.hide();
			$checkInMob.hide();
			$viewBookingMob.hide();
			$mhStayMob.hide();
			$mhUpgradeMob.hide();
			$loginMob.hide();
			$loggedinMob.hide();
			$errorValidationGen.hide();
			$errorValidationFlightGen.hide();
			$bookingFormTitle.removeClass('has-error');
			$inputValidator.removeClass('has-error');
			$selectizeInputGen.removeClass('has-error');
			$statusFlightDateSelectize.removeClass('has-error');
			$statusFromLocSelectize.removeClass('has-error');
			$statusToLocSelectize.removeClass('has-error');
			$statusFlightNoDateSelectize.removeClass('has-error');
		});

		$moreLinksFlightStatus.on('click', () =>{
			$ibeNav.find('li').removeClass('selected');
			$ibeNav.find('.more-links').parent().addClass('selected');
			if ($('.enrich-revamp').length > 0) {
				$('.enrich-revamp .enrich-header #mab-bookingnav .navbar-default').removeClass('mholidays-navbar');
			}
			_self.$scope.show();
			$bookFlight.hide();
			$flightUpgrade.hide();
			$checkIn.hide();
			$viewBooking.hide();
			$mhStay.hide();
			$mhUpgrade.hide();
			$login.hide();
			$moreLinks.hide();
			$mhHolidays.hide();
			$loggedin.addClass('hidden');
			_self.$scopeMob.show();
			$bookFlightMob.hide();
			$checkInMob.hide();
			$viewBookingMob.hide();
			$mhStayMob.hide();
			$mhUpgradeMob.hide();
			$loginMob.hide();
			$loggedinMob.hide();
			$errorValidationGen.hide();
			$errorValidationFlightGen.hide();
			$bookingFormTitle.removeClass('has-error');
			$inputValidator.removeClass('has-error');
			$selectizeInputGen.removeClass('has-error');
			$statusFlightDateSelectize.removeClass('has-error');
			$statusFromLocSelectize.removeClass('has-error');
			$statusToLocSelectize.removeClass('has-error');
			$statusFlightNoDateSelectize.removeClass('has-error');
		});


		// IBE Navigation show/hide Mobile Flight status container
		$('.mobile-flight-status').on('click', () => {
			$ibeNavList.removeClass('selected');
			$('.mobile-flight-status').parent().addClass('selected');
			_self.$scopeMob.find('.status-cities').parent().addClass('selected');
			_self.$scopeMob.show();
			$bookFlightMob.hide();
			$checkInMob.hide();
			$viewBookingMob.hide();
			$mhStayMob.hide();
			$mhUpgradeMob.hide();
			$loginMob.hide();
			$loggedinMob.hide();
			$mobMholidays.hide();
			$flightupgradeMob.hide();
			$moreLinksMob.hide();
			$errorValidationGen.hide();
			$errorValidationFlightGen.hide();
			$bookingFormTitle.removeClass('has-error');
			$inputValidator.removeClass('has-error');
			$selectizeInputGen.removeClass('has-error');
			// trigger resize event to redraw table
			$(window).resize();
			$statusFlightDateSelectize.removeClass('has-error');
			$statusFromLocSelectize.removeClass('has-error');
			$statusToLocSelectize.removeClass('has-error');
			$statusFlightNoDateSelectize.removeClass('has-error');

			bcommon.scrollToTopIBE();


			if(window.innerWidth > 767 && window.innerWidth<1200){
			$ibeNav.find('li').removeClass('selected');
			$('.flight-status').parent().addClass('selected');
			_self.$scope.show();
			$bookFlight.hide();
			$checkIn.hide();
			$viewBooking.hide();
			$flightupgradeMob.hide();
			$mhStay.hide();
			$mhUpgrade.hide();
			$login.hide();
			$mhHolidays.hide();
			$loggedin.addClass('hidden');
			_self.$scopeMob.show();
			$bookFlightMob.hide();
			$checkInMob.hide();
			$viewBookingMob.hide();
			$mhStayMob.hide();
			$mhUpgradeMob.hide();
			$loginMob.hide();
			$loggedinMob.hide();
			$errorValidationGen.hide();
			$errorValidationFlightGen.hide();
			$bookingFormTitle.removeClass('has-error');
			$inputValidator.removeClass('has-error');
			$selectizeInputGen.removeClass('has-error');
			$statusFlightDateSelectize.removeClass('has-error');
			$statusFromLocSelectize.removeClass('has-error');
			$statusToLocSelectize.removeClass('has-error');
			$statusFlightNoDateSelectize.removeClass('has-error');
			}
			if ($('.enrich-revamp').length > 0) {
				$('.enrich-revamp .enrich-header').addClass('hide');	
				$('.enrich-revamp .enrich-mobile-ibe-container').removeClass('hide');			
				let targetHeight: any = $(window).innerHeight() + 'px';
				$('.enrich-revamp #mob-flightstatus--container').css('height', targetHeight);					
			}
		});

		// Overlay container - IBE Navigation show/hide Mobile Check in container
		$navOverlay.find('.mobile-flight-status').on('click', () => {
			$ibeNavList.removeClass('selected');
			$mobIbeNav.find('.mobile-flight-status').parent().addClass('selected');
			_self.$scopeMob.find('.status-cities').parent().addClass('selected');
			_self.$scopeMob.show();
			$bookFlightMob.hide();
			$checkInMob.hide();
			$viewBookingMob.hide();
			$mhStayMob.hide();
			$mhUpgradeMob.hide();
			$flightupgradeMob.hide();
			$loginMob.hide();
			$loggedinMob.hide();
			$errorValidationGen.hide();
			$errorValidationFlightGen.hide();
			$bookingFormTitle.removeClass('has-error');
			$inputValidator.removeClass('has-error');
			$selectizeInputGen.removeClass('has-error');
			$statusFlightDateSelectize.removeClass('has-error');
			$statusFromLocSelectize.removeClass('has-error');
			$statusToLocSelectize.removeClass('has-error');
			$statusFlightNoDateSelectize.removeClass('has-error');
			bcommon.scrollToTopIBE();

			if (window.innerWidth > 767 && window.innerWidth<1200){
			$ibeNav.find('li').removeClass('selected');
			$('.flight-status').parent().addClass('selected');
			_self.$scope.show();
			$bookFlight.hide();
			$checkIn.hide();
			$viewBooking.hide();
			$mhStay.hide();
			$mhUpgrade.hide();
			$login.hide();
			$mhHolidays.hide();
			$loggedin.addClass('hidden');
			_self.$scopeMob.show();
			$bookFlightMob.hide();
			$checkInMob.hide();
			$viewBookingMob.hide();
			$mhStayMob.hide();
			$mhUpgradeMob.hide();
			$loginMob.hide();
			$loggedinMob.hide();
			$errorValidationGen.hide();
			$errorValidationFlightGen.hide();
			$bookingFormTitle.removeClass('has-error');
			$inputValidator.removeClass('has-error');
			$selectizeInputGen.removeClass('has-error');
			$statusFlightDateSelectize.removeClass('has-error');
			$statusFromLocSelectize.removeClass('has-error');
			$statusToLocSelectize.removeClass('has-error');
			$statusFlightNoDateSelectize.removeClass('has-error');
			}
		});
		
	}

	/**
	 * [flight StatusCities]
	 * - tab handlers
	 * - form submission
	 */
	flightStatusCities(): void {
		let _self = this;

		let tabCities:any = $('.status-cities');
		let tabCitiesMob:any = $('#mob-flightstatus--container .status-cities');

		// tab handlers
		tabCities.click(() =>{
			_self.$statusCitiesContainer.show();
			_self.$statusFlightnoContainer.hide();
			_self.$scope.find('.flightstatus-list li').removeClass('selected');
			_self.$scope.find('.status-cities').parent().addClass('selected');
		});

		tabCitiesMob.click(() =>{
			_self.$statusCitiesContainer.show();
			_self.$statusFlightnoContainer.hide();
			_self.$scopeMob.find('.flightstatus-list li').removeClass('selected');
			_self.$scopeMob.find('.status-cities').parent().addClass('selected');
		});

		let $statusCitiesSubmitBtn:any = _self.$scope.find('.statusCitiesSubmit');
		let $statusCitiesSubmitBtnMob:any = _self.$scopeMob.find('.statusCitiesSubmit');

		// validate statusCities form (desktop)
		$statusCitiesSubmitBtn.click((evt:any) => {
			// console.log('des click');
			let _self = this;
			evt.preventDefault();
			adobeDataLayer.push('click', {
                'clickName': 'click:btn-click:flight-status-cities-search',
                'componentType': 'btn',
                'componentName': 'Cities Search',
                'componentID': '',
				'attributes': []
            });
			this.$flightStatusError = [];
			_self.$statusCitiesValidator.empty();
			_self.$statusCitiesErrorValidation.show();

			let flightDate:any      = _self.$scope.find('.status-flight--date');
			let fromLocationSel:any = _self.$scope.find('.status-from--location');
			let toLocationSel:any   = _self.$scope.find('.status-to--location');
			// console.log(flightDate, fromLocationSel, toLocationSel);

			flightFormValidation(this.$flightStatusError, flightDate, fromLocationSel, toLocationSel);
		});

		// validate statusCities form (mobile)
		$statusCitiesSubmitBtnMob.click((evt:any) => {
			// console.log('mob click');
			let _self = this;
			evt.preventDefault();
			this.$flightStatusError = [];
			_self.$statusCitiesValidator.empty();
			_self.$statusCitiesErrorValidation.show();

			let mobFlightDate:any      = _self.$scopeMob.find('.status-flight--date');
			let mobFromLocationSel:any = _self.$scopeMob.find('.status-from--location');
			let mobToLocationSel:any   = _self.$scopeMob.find('.status-to--location');
			// console.log(mobFlightDate, mobFromLocationSel, mobToLocationSel);

			flightFormValidation(this.$flightStatusError, mobFlightDate, mobFromLocationSel, mobToLocationSel);
		});

		function flightFormValidation(errorObj:any, dateEl:any, fromLocEl:any, toLocEl:any) {
			let dateValidate:boolean    = true;
			let fromLocValidate:boolean = true;
			let toLocValidate:boolean   = true;
			let dupLocValidate:boolean  = true;

			// empty field validation
			// - flight date
			if (dateEl.val() == '') {
				dateEl.parent().find('.selectize-control .selectize-input').addClass('has-error');
				dateEl.parent().find('.booking-form--title').addClass('has-error');
				let $flightStatusDate:any = dateEl.attr('data-departdate');
				errorObj.push({'el': dateEl, 'msg': $flightStatusDate});
				// console.log('date failed');
				dateValidate = false;
			} else{
				dateEl.parent().find('.selectize-control .selectize-input').removeClass('has-error');
				dateEl.parent().find('.booking-form--title').removeClass('has-error');
				// console.log('date passed');
				dateValidate = true;
			}

			// empty field validation
			// - from location
			if (fromLocEl.val() == '') {
				fromLocEl.parent().find('.selectize-control .selectize-input').addClass('has-error');
				fromLocEl.parent().find('.booking-form--title').addClass('has-error');
				$('#mob-flightstatus--container .status-from--location-input').parent().addClass('has-error');
				$('#mob-flightstatus--container .status-from--location-input').parent().find('.booking-form--title').addClass('has-error');
				let $statusFromLocation:any = fromLocEl.attr('data-statusfromlocation');
				errorObj.push({'el': fromLocEl, 'msg': $statusFromLocation});
				// console.log('fromloc failed');
				fromLocValidate = false;
			} else{
				fromLocEl.parent().find('.selectize-control .selectize-input').removeClass('has-error');
				fromLocEl.parent().find('.booking-form--title').removeClass('has-error');
				$('#mob-flightstatus--container .status-from--location-input').parent().removeClass('has-error');
				$('#mob-flightstatus--container .status-from--location-input').parent().find('.booking-form--title').removeClass('has-error');
				// console.log('fromloc passed');
				fromLocValidate = true;
			}

			// empty field validation
			// - to location
			if (toLocEl.val() == '') {
				let _self = this;
				toLocEl.parent().find('.selectize-control .selectize-input').addClass('has-error');
				toLocEl.parent().find('.booking-form--title').addClass('has-error');
				$('#mob-flightstatus--container .status-to--location-input').parent().addClass('has-error');
				$('#mob-flightstatus--container .status-to--location-input').parent().find('.booking-form--title').addClass('has-error');
				let $statusToLocation:any = toLocEl.attr('data-statustolocation');
				errorObj.push({'el': toLocEl, 'msg': $statusToLocation});
				// console.log('toloc failed');
				toLocValidate = false;
			} else{
				toLocEl.parent().find('.selectize-control .selectize-input').removeClass('has-error');
				toLocEl.parent().find('.booking-form--title').removeClass('has-error');
				$('#mob-flightstatus--container .status-to--location-input').parent().removeClass('has-error');
				$('#mob-flightstatus--container .status-to--location-input').parent().find('.booking-form--title').removeClass('has-error');
				// console.log('toloc passed');
				toLocValidate = true;
			}

			// duplicate value validation
			// - from & to fields
			if (fromLocEl.val() !== '' && toLocEl.val() !== '') {
				if (fromLocEl.val() === toLocEl.val()) {
					toLocEl.parent().find('.selectize-control .selectize-input').addClass('has-error');
					toLocEl.parent().find('.booking-form--title').addClass('has-error');
					$('#mob-flightstatus--container .status-to--location-input').parent().addClass('has-error');
					$('#mob-flightstatus--container .status-to--location-input').parent().find('.booking-form--title').addClass('has-error');
					let $statusfromLoLocValidate:any = fromLocEl.attr('data-statusfromtoLoc');
					errorObj.push({'el': [fromLocEl, toLocEl], 'msg': $statusfromLoLocValidate});
					// console.log('fail dup loc');
					dupLocValidate = false;
				} else {
					dupLocValidate = true;
				}
			}

			// error message generation
			_self.$statusCitiesValidator.append('<ul class="validation--error-list"></ul>');
			let validationMessageList = _self.$statusCitiesValidator.find('.validation--error-list');

			_self.flightStatusErrorMessageGenerate(errorObj, validationMessageList);

			if (dateValidate && fromLocValidate && toLocValidate && dupLocValidate) {
				_self.$statusCitiesErrorValidation.hide();
				let urlParams:string = 'fDate=' + encodeURI(dateEl.val() + '&fFrom=' + fromLocEl.val() + '&fTo=' + toLocEl.val());
				//_self.flightStatusFormSubmit(urlParams);
				let lang:any = _self.getLanguage();
				window.open(_self.$scope.attr('data-get-flightstatus-url')+'?language='+lang+'&departureDate='+encodeURI(dateEl.val()+'&departureCity='+fromLocEl.val()+'&arrivalCity='+toLocEl.val()),'_blank');
			} else {
				// console.log('Fail');
				console.log({
					'dateValidate': 	dateValidate,
					'fromLocValidate': 	fromLocValidate,
					'toLocValidate': 	toLocValidate,
					'dupLocValidate': 	dupLocValidate
				});
			}
		}
	}

	/**
	 * [flight StatusFlightNo]
	 * - tab handlers
	 * - form submission
	 */
	flightStatusFlightNo(): void {
		let _self = this;

		// tab handlers
		let tabFlightNo:any = $('.status-flightno');
		let tabFlightNoMob:any = $('#mob-flightstatus--container .status-flightno');

		tabFlightNo.click(() =>{
			_self.$statusCitiesContainer.hide();
			_self.$statusFlightnoContainer.show();
			_self.$scope.find('.flightstatus-list li').removeClass('selected');
			_self.$scope.find('.status-flightno').parent().addClass('selected');
		});

		tabFlightNoMob.click(() =>{
			_self.$statusCitiesContainer.hide();
			_self.$statusFlightnoContainer.show();
			_self.$scopeMob.find('.flightstatus-list li').removeClass('selected');
			_self.$scopeMob.find('.status-flightno').parent().addClass('selected');
		});

		let $statusFlightnoSubmitBtn:any = _self.$scope.find('.statusFlightNoSubmit');
		let $statusFlightnoSubmitBtnMob:any = _self.$scopeMob.find('.statusFlightNoSubmit');

		// validate StatusFlightNo form (desktop)
		$statusFlightnoSubmitBtn.click((evt:any) => {
			evt.preventDefault();
			adobeDataLayer.push('click', {
                'clickName': 'click:btn-click:flight-number-search',
                'componentType': 'btn',
                'componentName': 'Flight Number',
                'componentID': '',
				'attributes': []
            });
			this.$flightStatusError = [];
			_self.$statusFlightnoValidator.empty();
			_self.$statusFlightnoErrorValidation.show();

			let statusFlightnoSel:any = _self.$scope.find('.status-flightno--date');
			let statusFlightNo:any    = _self.$scope.find('.status-flight--no');
			// console.log(statusFlightnoSel, statusFlightNo);

			flightFormValidation(this.$flightStatusError, statusFlightnoSel, statusFlightNo);
		});

		// validate StatusFlightNo form (mobile)
		$statusFlightnoSubmitBtnMob.click((evt:any) => {
			evt.preventDefault();
			adobeDataLayer.push('click', {
                'clickName': 'click:btn-click:flight-number-search',
                'componentType': 'btn',
                'componentName': 'Flight Number',
                'componentID': '',
				'attributes': []
            });
			this.$flightStatusError = [];
			_self.$statusFlightnoValidator.empty();
			_self.$statusFlightnoErrorValidation.show();

			let mobStatusFlightnoSel:any = _self.$scopeMob.find('.status-flightno--date');
			let mobStatusFlightNo:any    = _self.$scopeMob.find('.status-flight--no');
			// console.log(mobStatusFlightnoSel, mobStatusFlightNo);

			flightFormValidation(this.$flightStatusError, mobStatusFlightnoSel, mobStatusFlightNo);
		});

		function flightFormValidation(errorObj:any, flightDate:any, flightNo:any) {
			let dateValidate:boolean    = true;
			let flightNoValidate:boolean = true;

			// empty field validation
			// - flight date
			if (flightDate.val() == '') {
				flightDate.parent().find('.selectize-control .selectize-input').addClass('has-error');
				flightDate.parent().find('.booking-form--title').addClass('has-error');
				let $statusFlightNoDate:any = flightDate.attr('data-departflightdate');
				errorObj.push({'el': flightDate, 'msg': $statusFlightNoDate});
				// console.log('dateval failed');
				dateValidate = false;
			} else{
				flightDate.parent().find('.selectize-control .selectize-input').removeClass('has-error');
				flightDate.parent().find('.booking-form--title').removeClass('has-error');
				// console.log('dateval passed');
				dateValidate = true;
			}

			// empty field validation
			// - flight date
			if (flightNo.val() == '') {
				flightNo.addClass('has-error');
				flightNo.parent().find('.booking-form--title').addClass('has-error');
				let $checkIneTicketValidate:any = flightNo.attr('data-statusflightno');
				errorObj.push({'el': flightNo, 'msg': $checkIneTicketValidate});
				// console.log('flightno failed');
				flightNoValidate = false;
			} else{
				flightNo.removeClass('has-error');
				flightNo.parent().find('.booking-form--title').removeClass('has-error');
				flightNoValidate = true;
				// console.log('flightno passed');
			}

			_self.$statusFlightnoValidator.append('<ul class="validation--error-list"></ul>');
			let validationMessageList = _self.$statusFlightnoValidator.find('.validation--error-list');

			_self.flightStatusErrorMessageGenerate(errorObj, validationMessageList);

			if (dateValidate && flightNoValidate) {
				let urlParams:string = 'fDate=' + encodeURI(flightDate.val() + '&fFNo=' + flightNo.val());
				_self.$statusFlightnoErrorValidation.hide();
				//_self.flightStatusFormSubmit(urlParams);
				let lang:any = _self.getLanguage();
				window.open(_self.$scope.attr('data-get-flightstatus-url')+'?language='+lang+'&departureDate='+encodeURI(flightDate.val()) + '&flightNumber='+flightNo.val(),'_blank');
			} else {
				// console.log('Fail');
				console.log({
					'dateValidate': 		dateValidate,
					'flightNoValidate': 	flightNoValidate,
				});
			}
		}
	}

	flightStatusErrorMessageGenerate(errObj:any, errContainer:any):void {
		$.each(errObj, function(i:any, obj:any) {
			if (obj.msg !== undefined) {
				let fieldLabel:string = '';
				// if obj.el is array (dup loc error)
				if (Array.isArray(obj.el)) {
					for (var j=0, len=obj.el.length; j<len; j++) {
						if(obj.el[j].selector == '#mob-flightstatus--container .status-to--location' || obj.el[j].selector == '#mob-flightstatus--container .status-from--location') {
							fieldLabel += $(obj.el[j].selector + '-input').parent().find('label').text() + ' & ';
						} else {
							fieldLabel += $(obj.el[j]).parent().find('label').text() + ' & ';
						}						
					}
					// remove last 3 chars ' & '
					fieldLabel = fieldLabel.substring(0, fieldLabel.length - 3);
				} else {
					fieldLabel = $(obj.el).parent().find('label').text();
					if(obj.el.selector == '#mob-flightstatus--container .status-to--location') {
						fieldLabel = $('#mob-flightstatus--container .status-to--location-input').parent().find('label').text();
					}
					if(obj.el.selector == '#mob-flightstatus--container .status-from--location') {
						fieldLabel = $('#mob-flightstatus--container .status-from--location-input').parent().find('label').text();
					}
				}				
				errContainer.append('<li data-id="'+i+'"><strong>'+ fieldLabel+':</strong> ' + obj.msg + '</li>');
			}
		});

	}
	getLanguage(){
	var curSite = window.location.href.split('/')[4];
	if (curSite) {
		var getLanguage = curSite;
		if(curSite.indexOf(".") > -1) {
		return getLanguage = curSite.substring(0,curSite.indexOf("."));
		}
	}
	}
	flightStatusFormSubmit(urlParams:any) {
		let _self = this;
		let _resultTable:any = _self.$scope.find('table');
		let _resultTableMob:any = _self.$scopeMob.find('table');
		// option 1: post to other page
		// // console.log('Success');
		// console.log(urlParams);
		// window.location.href = window.location.origin + urlParams;

		// option 2: get request for new data to post on same page
		let getData:any = (urlParams:any) => {
			let defer = $.Deferred();
			let dataFlightStatusUrl:string = _self.$scope.attr('data-get-flightstatus-url');

			$.get(dataFlightStatusUrl, urlParams)
				.done((data:any) => {
					defer.resolve(data);
				})
				.fail((error:any) => {
					defer.reject(error);
				});

			return defer.promise();
		};

		getData(urlParams).then((data:any) => {
			console.log(data);
			let flightData = data.flight_status_data;
			_self.$scope.find('.status-flight__search-results').slideDown(400, () => {
				_resultTable.DataTable().clear().draw();
				for (var i=0, len=flightData.length; i<len; i++) {
					let formattedRow:any = formatOutputDatarow(flightData[i]);
					console.log(formattedRow);
					populateTableData(_resultTable, formattedRow);
				}
			});
			_self.$scope.find('[data-flight-status-timestamp]').text(data.last_update);
			_self.$scope.find('.flightstatus-searchresults__timestamp').removeClass('hidden');

			_self.$scopeMob.find('.status-flight__search-results').slideDown(400, () => {
				_resultTableMob.DataTable().clear().draw();
				for (var i=0, len=flightData.length; i<len; i++) {
					let formattedRow:any = formatOutputDatarow(flightData[i]);
					populateTableData(_resultTableMob, formattedRow);
				}
			});
			_self.$scopeMob.find('[data-flight-status-timestamp]').text(data.last_update);
			_self.$scopeMob.find('.flightstatus-searchresults__timestamp').removeClass('hidden');
		});

		function formatOutputDatarow(rawData:any) {
			let formattedStatus:string = '<span class="state-' + ((rawData.flight_status).trim()).replace(/ /g, '-') + '">' + rawData.flight_status + '</span>';
			let formattedDeparture:string;
			let formattedArrival:string;
			if (rawData.flight_departure_city == "London-Heathrow"||
				rawData.flight_departure_city == "Belfast"||
				rawData.flight_departure_city == "Glasgow"|| 
				rawData.flight_departure_city == "Aberdeen"|| 
				rawData.flight_departure_city == "Edinburgh"|| 
				rawData.flight_departure_city == "Newcastle"|| 
				rawData.flight_departure_city == "Birmingham") {
				formattedDeparture = '<div class="location">' + rawData.flight_departure_city + '</div><div class="timing"><span class="time">' + moment(rawData.flight_departure_date_time).format('DD/MM/YYYY') + '</span><span class="sep"> - </span><span class="date">' + moment(rawData.flight_departure_date_time).subtract(3600, 'seconds').format('HH:mm:ss'); + '</span></div>';			
			} else if (
				rawData.flight_departure_city == "Mildura"||
				rawData.flight_departure_city == "Melbourne" ||
				rawData.flight_departure_city == "Sydney" ||
				rawData.flight_departure_city == "Adelaide" ||
				rawData.flight_departure_city == "Emerald" ||
				rawData.flight_departure_city == "Auckland" ||
				rawData.flight_departure_city == "Hobart") {
				formattedDeparture = '<div class="location">' + rawData.flight_departure_city + '</div><div class="timing"><span class="time">' + moment(rawData.flight_departure_date_time).format('DD/MM/YYYY') + '</span><span class="sep"> - </span><span class="date">' + moment(rawData.flight_departure_date_time).add(3600, 'seconds').format('HH:mm:ss'); + '</span></div>';			
			} else {
				formattedDeparture = '<div class="location">' + rawData.flight_departure_city + '</div><div class="timing"><span class="time">' + moment(rawData.flight_departure_date_time).format('DD/MM/YYYY') + '</span><span class="sep"> - </span><span class="date">' + moment(rawData.flight_departure_date_time).format('HH:mm:ss') + '</span></div>';
			}

			if (rawData.flight_arrival_city == "London-Heathrow"||
				rawData.flight_arrival_city == "Belfast"||
				rawData.flight_arrival_city == "Glasgow"|| 
				rawData.flight_arrival_city == "Aberdeen"|| 
				rawData.flight_arrival_city == "Edinburgh"|| 
				rawData.flight_arrival_city == "Newcastle"|| 
				rawData.flight_arrival_city == "Birmingham") {
				formattedArrival = '<div class="location">' + rawData.flight_arrival_city + '</div><div class="timing"><span class="time">' + moment(rawData.flight_arrival_date_time).format('DD/MM/YYYY') + '</span><span class="sep"> - </span><span class="date">' + moment(rawData.flight_arrival_date_time).subtract(3600, 'seconds').format('HH:mm:ss'); + '</span></div>';			
			} else if (
				rawData.flight_arrival_city == "Mildura" ||
				rawData.flight_arrival_city == "Melbourne" ||
				rawData.flight_arrival_city == "Sydney" ||
				rawData.flight_arrival_city == "Adelaide" ||
				rawData.flight_arrival_city == "Emerald" ||
				rawData.flight_arrival_city == "Auckland" ||
				rawData.flight_arrival_city == "Hobart") {
				formattedArrival = '<div class="location">' + rawData.flight_arrival_city + '</div><div class="timing"><span class="time">' + moment(rawData.flight_arrival_date_time).format('DD/MM/YYYY') + '</span><span class="sep"> - </span><span class="date">' + moment(rawData.flight_arrival_date_time).add(3600, 'seconds').format('HH:mm:ss'); + '</span></div>';			
			} else {
				formattedArrival = '<div class="location">' + rawData.flight_arrival_city + '</div><div class="timing"><span class="time">' + moment(rawData.flight_arrival_date_time).format('DD/MM/YYYY') + '</span><span class="sep"> - </span><span class="date">' + moment(rawData.flight_arrival_date_time).format('HH:mm:ss') + '</span></div>';
			}

			let formattedData:any = {
				flightNo: rawData.flight_no,
				status: formattedStatus,
				departure: formattedDeparture,
				arrival: formattedArrival
			};

			return formattedData;
		}

		function populateTableData(el:any, data:any) {
			el.DataTable().row.add(data).draw();
		}
	}

	initTables(): void {
		let _self = this;
		let _resultTable:any = _self.$scope.find('table');
		let _resultTableMob:any = _self.$scopeMob.find('table');

		// add 100% width to table to remove hard js generated table width
		_resultTable.css('width', '100%');
		_resultTable.attr('data-slideout-ignore','');
		let _resultDt:any = _resultTable.DataTable({
			serverSide: false,
			responsive: true,
			paging: 	false,
			info: 		false,
			searching: 	false,
			dom: 		'frtipl',
			columns: [
			{
				title: 'Flight No.',
				data: 'flightNo',
				class: 'flight-no'
			},
			{
				title: 'Status',
				data: 'status',
				class: 'status'
			},
			{
				title: 'Departure',
				data: 'departure',
				class: 'departure'
			},
			{
				title: 'Arrival',
				data: 'arrival',
				class: 'arrival'
			}
			],
			columnDefs: [ {
				"targets"  : 'no-sort',
				"orderable": false,
			}]
		});

		_resultTableMob.css('width', '100%');
		_resultTableMob.attr('data-slideout-ignore','');
		let _resultDtMob:any = _resultTableMob.DataTable({
			serverSide: false,
			responsive: true,
			paging: 	false,
			info: 		false,
			searching: 	false,
			dom: 		'frtipl',
			columns: [
			{
				title: 'Flight No.',
				data: 'flightNo',
				class: 'flight-no'
			},
			{
				title: 'Status',
				data: 'status',
				class: 'status'
			},
			{
				title: 'Departure',
				data: 'departure',
				class: 'departure'
			},
			{
				title: 'Arrival',
				data: 'arrival',
				class: 'arrival'
			}
			],
			columnDefs: [ {
				"targets"  : 'no-sort',
				"orderable": false,
				}, {
	            	responsivePriority: 1,
	            	targets: 0
	            }],
			initComplete: (settings:any, json:any) => {
				// console.log('initComplete');
				// console.log(settings, json);
			},
			drawCallback: (settings:any) => {
				// console.log('DataTables has redrawn the table');
			}
		});
	}

	getThreeDays(): void {
		let _self = this;
		let $statusFlightDate:any = document.getElementById('statusFlightDate');
		let $statusFlightNoDate:any = document.getElementById('statusFlightNoDate');
		let $statusFlightDateMob:any = document.getElementById('statusFlightDateMob');
		let $statusFlightNoDateMob:any = document.getElementById('statusFlightNoDateMob');
		let $statusFlightDateInputSel: any = _self.$scope.find('.status-flight--date');
		let $statusFlightNoDateInputSel: any = _self.$scope.find('.status-flightno--date');
		let $scopeMob: any = $('#mob-flightstatus--container');
		let $statusFlightDateInputMobSel: any = $scopeMob.find('.status-flight--date');
		let $statusFlightNoDateInputMobSel: any = $scopeMob.find('.status-flightno--date');
		let $monthNames:any = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
		let $todaysDate:string = moment(new Date()).format("YYYY-MM-DD");

		for(let $day:any = -1; $day < 4; $day++) {
			let $date:any = new Date();
			$date.setDate($date.getDate() + $day);
			$statusFlightDate.options[$statusFlightDate.options.length] = new Option([$date.getDate(), $monthNames[$date.getMonth()], $date.getFullYear()].join(' '), moment($date).format("YYYY-MM-DD"));
			$statusFlightNoDate.options[$statusFlightNoDate.options.length] = new Option([$date.getDate(), $monthNames[$date.getMonth()], $date.getFullYear()].join(' '), moment($date).format("YYYY-MM-DD"));
			$statusFlightDateMob.options[$statusFlightDateMob.options.length] = new Option([$date.getDate(), $monthNames[$date.getMonth()], $date.getFullYear()].join(' '), moment($date).format("YYYY-MM-DD"));
			$statusFlightNoDateMob.options[$statusFlightNoDateMob.options.length] = new Option([$date.getDate(), $monthNames[$date.getMonth()], $date.getFullYear()].join(' '), moment($date).format("YYYY-MM-DD"));
		}


		$statusFlightDateInputSel.selectize({
			onInitialize: function() {
				_self.wcag.selectizeInputAria($statusFlightDateInputSel[0].selectize);
				// set date to current day (second option)
				$statusFlightDateInputSel[0].selectize.setValue($todaysDate);
			},
		});

		$statusFlightNoDateInputSel.selectize({
			onInitialize: function() {
				_self.wcag.selectizeInputAria($statusFlightNoDateInputSel[0].selectize);
				// set date to current day (second option)
				$statusFlightNoDateInputSel[0].selectize.setValue($todaysDate);
			},
		});

		$statusFlightDateInputMobSel.selectize({
			onInitialize: function() {
				_self.wcag.selectizeInputAria($statusFlightDateInputMobSel[0].selectize);
				// set date to current day (second option)
				$statusFlightDateInputMobSel[0].selectize.setValue($todaysDate);
			},
		});

		$statusFlightNoDateInputMobSel.selectize({
			onInitialize: function() {
				_self.wcag.selectizeInputAria($statusFlightNoDateInputMobSel[0].selectize);
				// set date to current day (second option)
				$statusFlightNoDateInputMobSel[0].selectize.setValue($todaysDate);
			},
		});


		$('.statusFlightDate .booking-form--title').addClass('input-filled');
		$('.statusFlightDate .selectize-control.single .selectize-input').addClass('select-filled');
		$('.statusFlightDate .selectize-input input').attr('readonly','readonly');
		$('.statusFlightNoDate .booking-form--title').addClass('input-filled');
		$('.statusFlightNoDate .selectize-control.single .selectize-input').addClass('select-filled');
		$('.statusFlightNoDate .selectize-input input').attr('readonly','readonly');
	}

	initSelectize(listItems:string): void {
		let _self = this;
		let bcommon = _self.bcommon;

		// desktop fields
		let $scope                  : any = $('#flight-status--container');
		let $statusFlightDate       : any = $scope.find('.statusFlightDate');
		let $statusFlightDateInput  : any = $scope.find('.status-flight--date');
		let $statusFromLoc          : any = $scope.find('.statusFromLocation');
		let $statusFromLocInput     : any = $scope.find('.status-from--location');
		let $statusToLoc            : any = $scope.find('.statusToLocation');
		let $statusToLocInput       : any = $scope.find('.status-to--location');
		let $statusFlightNoDate     : any = $scope.find('.statusFlightNoDate');
		let $statusFlightNoDateInput: any = $scope.find('.status-flightno--date');		

		$statusFromLocInput.html(listItems);
		$statusFromLocInput.selectize({
			onInitialize: function() {
				_self.wcag.selectizeInputAria($statusFromLocInput[0].selectize);
			},
			onFocus: function() {
				$statusFromLoc.find('.booking-form--title').addClass('input-filled');
				$statusFromLoc.find('.selectize-control.single .selectize-input').addClass('select-filled');
				$statusFromLocInput.parent().find('.selectize-control .selectize-input').removeClass('has-error');
				$statusFromLocInput.parent().find('.booking-form--title').removeClass('has-error');
				let $fromLocationChange = $statusFromLocInput.find('option:selected').text();				
				if($fromLocationChange !== '') {
					$statusFromLocInput[0].selectize.clear();
				}
			},
			onChange: function(value:string) {
				$statusFromLoc.find('.booking-form--title').addClass('input-filled');
				$statusFromLoc.find('.selectize-control.single .selectize-input').addClass('select-filled');
				if (value.length) { // only get new toLocation values if fromLocation val is filled (do nothing if empty value)
					bcommon.updateAirportOnDListOnFlowChangeNew("flightstatus", value, $statusToLocInput);
				}
			},
			onBlur: function() {
				let $statusFromLocationChange = $statusFromLocInput.find('option:selected').text();
				if ($statusFromLocationChange == '') {
					$statusFromLoc.find('.booking-form--title').removeClass('input-filled');
					$statusFromLoc.find('.selectize-control.single .selectize-input').removeClass('select-filled');
				} else {
					$statusFromLoc.find('.booking-form--title').addClass('input-filled');
					$statusFromLoc.find('.selectize-control.single .selectize-input').addClass('select-filled');
				}
			},
			onLoad: function(data:any) {
				$statusFromLocInput[0].selectize.trigger('blur');
			},
			lockOptgroupOrder: true,
			searchField: ['text'],
			selectOnTab: true,
			render: {
				item: function (item: any, escape: any) {
					return '<div>' +
						(item.text ? '<span class = "airportname">' + escape(item.text.split('|')[0].split('__')[0]) + ' (' + escape(item.text.split('|')[2]) + ')</span>' : '') +
						'</div>';

				},
				option: function (item: any, escape: any) {
					return '<div>' +
						(item.text ? '<span class = "airportname">' + escape(item.text.split('|')[0].split('__')[0]) + ',</span> ' +
							escape(item.text.split('|')[1]) + '<span class = "airportcode">' +
							escape(item.text.split('|')[2]) + '</span>' : '') +
						'</div>';
				}
			}
		});

		$statusToLocInput.html(listItems);
		$statusToLocInput.selectize({
			onInitialize: function() {
				_self.wcag.selectizeInputAria($statusToLocInput[0].selectize);
			},
			onFocus: function() {
				$statusToLoc.find('.booking-form--title').addClass('input-filled');
				$statusToLoc.find('.selectize-control.single .selectize-input').addClass('select-filled');
				$statusToLocInput.parent().find('.selectize-control .selectize-input').removeClass('has-error');
				$statusToLocInput.parent().find('.booking-form--title').removeClass('has-error');
				let $toLocationChange = $statusToLocInput.find('option:selected').text();				
				if($toLocationChange !== '') {
					$statusToLocInput[0].selectize.clear();
				}
			},
			onChange: function(value: any) {
				$statusToLoc.find('.booking-form--title').addClass('input-filled');
				$statusToLoc.find('.selectize-control.single .selectize-input').addClass('select-filled');
				if ($statusFromLocInput.val() === $statusToLocInput.val()) {
					$statusToLocInput.parent().find('.selectize-control .selectize-input').addClass('has-error');
					$statusToLocInput.parent().find('.booking-form--title').addClass('has-error');
				}
				else{
					$statusToLocInput.parent().find('.selectize-control .selectize-input').removeClass('has-error');
					$statusToLocInput.parent().find('.booking-form--title').removeClass('has-error');
				}
			},
			onBlur: function() {
				let $toLocationChange = $statusToLocInput.find('option:selected').text();
				if ($toLocationChange == '') {
					$statusToLoc.find('.booking-form--title').removeClass('input-filled');
					$statusToLoc.find('.selectize-control.single .selectize-input').removeClass('select-filled');
				} else {
					$statusToLoc.find('.booking-form--title').addClass('input-filled');
					$statusToLoc.find('.selectize-control.single .selectize-input').addClass('select-filled');
				}
			},
			onLoad: function(data:any) {
				_self.fillToPrepopValue($statusToLocInput[0].selectize);
				$statusToLocInput[0].selectize.trigger('blur');
			},
			lockOptgroupOrder: true,
			searchField: ['text'],
			selectOnTab: true,
			render: {
				item: function (item: any, escape: any) {
					return '<div>' +
						(item.text ? '<span class = "airportname">' + escape(item.text.split('|')[0].split('__')[0]) + ' (' + escape(item.text.split('|')[2]) + ')</span>' : '') +
						'</div>';
				},
				option: function (item: any, escape: any) {
					return '<div>' +
						(item.text ? '<span class = "airportname">' + escape(item.text.split('|')[0].split('__')[0]) + ',</span> ' + escape(item.text.split('|')[1]) + '<span class = "airportcode">' + escape(item.text.split('|')[2]) + '</span>' : '') +
						'</div>';
				}
			}
		});

		// Mobile fields
		let $scopeMob                  : any = $('#mob-flightstatus--container');
		let $statusFlightDateMob       : any = $scopeMob.find('.statusFlightDate');
		let $statusFlightDateInputMob  : any = $scopeMob.find('.status-flight--date');
		let $statusFromLocMob          : any = $scopeMob.find('.statusFromLocation');
		let $statusFromLocInputMob     : any = $scopeMob.find('.status-from--location');
		let $statusToLocMob            : any = $scopeMob.find('.statusToLocation');
		let $statusToLocInputMob       : any = $scopeMob.find('.status-to--location');
		let $statusFlightNoDateMob     : any = $scopeMob.find('.statusFlightNoDate');
		let $statusFlightNoDateInputMob: any = $scopeMob.find('.status-flightno--date');

		let $fromLocationMobileInput: any = $scopeMob.find('.status-from--location-input');
		let $toLocationMobileInput: any = $scopeMob.find('.status-to--location-input');

		$fromLocationMobileInput.magnificPopup({
			items: {
				src: '#fs-from-location-popup'
			},
			type: 'inline',
			preloader: false,
			alignTop: true,
			showCloseBtn: true,
			callbacks: {
				open: function () {
					let instance = this;
					let $el: any = instance.content;
					$('#fs-from-location-popup .selectize-input')[0].click();
					$('#fs-from-location-popup .selectize-input')[0].focus();
					if ($statusFromLocInputMob.text() === '') {
						$("#fs-from-title").show();
					} else {
						$("#fs-from-title").hide();
					}
					if (window.innerWidth < 768) 
					{
						let userAgent:any = navigator.userAgent || navigator.vendor;
						if( userAgent.match( /iPhone/i ))
						{
							$el.parent().parent().parent().css({ 'top': '0px' });
						}
						$el.css({ 'padding': '0', 'height': '100%' });
						$el.parent().css({ 'height': '100%' });
						$el.parent().parent().css({ 'padding': '0' });
						$('body').css('height', $(window).height());
						$('body').css('overflow', 'hidden');
					}
				},
				close: function () {
					$('body').css('overflow', '');
					$('body').css('height', '');
				},
				afterClose: function () {
					if ($statusFromLocInputMob.text() !== "") {
						let $fromLocationMobTitle: any = $fromLocationMobileInput.parent().find('.booking-form--title');
						$fromLocationMobTitle.addClass('input-filled');

						$fromLocationMobileInput.html('<div>' +
							($statusFromLocInputMob.text() ? '<span class = "airportname airportselected">' + $statusFromLocInputMob.text().trim().split('|')[0] + ' (' + $statusFromLocInputMob.text().trim().split('|')[2] + ')</span>' : '') +
							'</div>');
						$.magnificPopup.open({
							items: {
								src: '#fs-to-location-popup'
							},
							type: 'inline',
							preloader: false,
							alignTop: true,
							showCloseBtn: true,
							callbacks: {
								open: function () {
									let instance = this;
									let $el: any = instance.content;
									$('#fs-to-location-popup .selectize-input')[0].click();
									$('#fs-to-location-popup .selectize-input')[0].focus();
									if ($statusToLocInputMob.text() === '') {
										$("#fs-to-title").show();
									} else {
										$("#fs-to-title").hide();
									}
									$fromLocationMobTitle.addClass('input-filled');
									$statusFromLocMob.find('.selectize-control.single .selectize-input').addClass('select-filled');
									let ibeFromLocationValMobile = $statusFromLocInputMob.val().trim().split('_')[0];

									if (window.innerWidth < 768) {
										$el.css({ 'padding': '0', 'height': '100%' });
										$el.parent().css({ 'height': '100%' });
										$el.parent().parent().css({ 'padding': '0' });
										$('body').css('height', $(window).height());
										$('body').css('overflow', 'hidden');
									}
								},
								close: function () {
									$('body').css('overflow', '');
									$('body').css('height', '');
								},
								afterClose: function () {												
									if ($statusToLocInputMob.text() !== "") {
										let $toLocationMobTitle: any = $toLocationMobileInput.parent().find('.booking-form--title');
										$toLocationMobTitle.addClass('input-filled');
										$toLocationMobileInput.html('<div>' +
											($statusToLocInputMob.text() ? '<span class = "airportname airportselected">' + $statusToLocInputMob.text().trim().split('|')[0] + ' (' + $statusToLocInputMob.text().trim().split('|')[2] + ')</span>' : '') +
											'</div>');
									} else {
										let $toLocationMobTitle: any = $toLocationMobileInput.parent().find('.booking-form--title');
										$toLocationMobTitle.removeClass('input-filled');
										$toLocationMobileInput.html('<div></div>');
									}
								}
							}
						}, 0);

					} else {
						let $fromLocationMobTitle: any = $fromLocationMobileInput.parent().find('.booking-form--title');
						$fromLocationMobTitle.removeClass('input-filled');
						$fromLocationMobileInput.html('<div></div>');
					}
				}
			}
		}, 0);

		$toLocationMobileInput.magnificPopup({
			items: {
				src: '#fs-to-location-popup'
			},			
			type: 'inline',			
			preloader: false,
			alignTop: true,			
			showCloseBtn: true,					
			callbacks: {
				open: function() {
					let instance = this;
					let $el: any = instance.content;
					let $fromLocationMobTitle: any = $fromLocationMobileInput.parent().find('.booking-form--title');
					$('#fs-to-location-popup .selectize-input')[0].click();
					$('#fs-to-location-popup .selectize-input')[0].focus();
					if ($statusToLocInputMob.text() === '') {
						$("#fs-to-title").show();				
					}else{
						$("#fs-to-title").hide();	
					}
					$fromLocationMobTitle.addClass('input-filled');
					$statusFromLocMob.find('.selectize-control.single .selectize-input').addClass('select-filled');					
					if (window.innerWidth < 768) {
						let userAgent:any = navigator.userAgent || navigator.vendor;
						if( userAgent.match( /iPhone/i ))
						{
							$el.parent().parent().parent().css({ 'top': '0px' });
						}
						$el.css({ 'padding': '0', 'height': '100%' });
						$el.parent().css({ 'height': '100%' });
						$el.parent().parent().css({ 'padding': '0' });						
						$('body').css('height', $(window).height());
						$('body').css('overflow', 'hidden');
					}
				},
				close: function () {
					$('body').css('overflow', '');
					$('body').css('height', '');
				},
				afterClose: function() {								
					if ($statusToLocInputMob.text() !== "") {
						let $toLocationMobTitle: any = $toLocationMobileInput.parent().find('.booking-form--title');
						$toLocationMobTitle.addClass('input-filled');
						$toLocationMobileInput.html('<div>' +
							($statusToLocInputMob.text() ? '<span class = "airportname airportselected">' + $statusToLocInputMob.text().trim().split('|')[0] + ' (' + $statusToLocInputMob.text().trim().split('|')[2] + ')</span>' : '') +
							'</div>');
					} else {
						let $toLocationMobTitle: any = $toLocationMobileInput.parent().find('.booking-form--title');
						$toLocationMobTitle.removeClass('input-filled');
						$toLocationMobileInput.html('<div></div>');
					}			
				}				
			}
		}, 0);		

		$statusFromLocInputMob.html(listItems);
		$statusFromLocInputMob.selectize({
			onInitialize: function() {
				_self.wcag.selectizeInputAria($statusFromLocInputMob[0].selectize);
			},
			onFocus: function() {
				$statusFromLocMob.find('.booking-form--title').addClass('input-filled');
				$statusFromLocMob.find('.selectize-control.single .selectize-input').addClass('select-filled');
				$statusFromLocInputMob.parent().find('.selectize-control .selectize-input').removeClass('has-error');
				$statusFromLocInputMob.parent().find('.booking-form--title').removeClass('has-error');
				let $fromLocationChange = $statusFromLocInputMob.find('option:selected').text();
				if($fromLocationChange !== '') {
					$statusFromLocInputMob[0].selectize.clear();
					$("#fs-from-title").show();
				}
			},
			onChange: function(value:string) {
				$statusFromLocMob.find('.booking-form--title').addClass('input-filled');
				$statusFromLocMob.find('.selectize-control.single .selectize-input').addClass('select-filled');
				if (value.length) { // only get new toLocation values if fromLocation val is filled (do nothing if empty value)
					bcommon.updateAirportOnDListOnFlowChangeNew("flightstatus", value, $statusToLocInputMob);
				}
				let miniibeCTAbutton: string = $('#mini-ibe-cta-button').length? $('#mini-ibe-cta-button').val() : '';
				if (value.trim() !== "" && $('#members-travel--subsidy').length < 1 && miniibeCTAbutton == ''){
					$.magnificPopup.close();
				}	
			},
			onBlur: function() {
				let $statusFromLocationChangeMob = $statusFromLocInputMob.find('option:selected').text();
				if ($statusFromLocationChangeMob == '') {
					$statusFromLocMob.find('.booking-form--title').removeClass('input-filled');
					$statusFromLocMob.find('.selectize-control.single .selectize-input').removeClass('select-filled');
				} else {
					$statusFromLocMob.find('.booking-form--title').addClass('input-filled');
					$statusFromLocMob.find('.selectize-control.single .selectize-input').addClass('select-filled');
					let miniibeCTAbutton: string = $('#mini-ibe-cta-button').length? $('#mini-ibe-cta-button').val() : '';
					if($('#members-travel--subsidy').length < 1 && miniibeCTAbutton == '') {
						if ($.magnificPopup.instance.isOpen) {
							$.magnificPopup.close();
						}
					}	
				}
				$statusFromLocInputMob.attr('data-ibeclicked', 'true');
			},
			lockOptgroupOrder: true,
			searchField: ['text'],
			selectOnTab: true,
			render: {
				item: function (item: any, escape: any) {
					return '<div>' +
						(item.text ? '<span class = "airportname airportselected">' + escape(item.text.split('|')[0].split('__')[0]) + ' (' + escape(item.text.split('|')[2]) + ')</span>' : '') +
						'</div>';

				},
				option: function (item: any, escape: any) {
					return '<div>' +
						(item.text ? '<p class = "airportline"><span class = "airportname">' + escape(item.text.split('|')[0].split('__')[0]) + '</span>' +
							'<span class = "airportcode">' +
							escape(item.text.split('|')[2]) + '</span></p><p>' + escape(item.text.split('|')[1]) + '</p>' : '') +
						'</div>';
				}
			}
		});

		$("#fs-from-location-popup .status-from--location .selectize-input input").blur(function (e: any) {
			let miniibeCTAbutton: string = $('#mini-ibe-cta-button').length ? $('#mini-ibe-cta-button').val() : '';
			if ($('#members-travel--subsidy').length < 1 && miniibeCTAbutton == '') {
				e.preventDefault();
				$("#fs-from-location-popup .status-from--location .selectize-dropdown").show();
			}
		});

		$("#fs-from-location-popup .status-from--location .selectize-input input").focusout(function (e: any) {
			let miniibeCTAbutton: string = $('#mini-ibe-cta-button').length ? $('#mini-ibe-cta-button').val() : '';
			if ($('#members-travel--subsidy').length < 1 && miniibeCTAbutton == '') {
				e.preventDefault();
				$('#fs-from-location-popup .selectize-input')[0].focus();
			}
		});

		$("#fs-from-location-popup .status-from--location .selectize-input input").keyup(function(){ 
			
			if ($("#fs-from-location-popup .status-from--location .selectize-input input").val() === '') {
				$("#fs-from-title").show();
			} else {
				$("#fs-from-title").hide();
			}			
		});

		$statusToLocInputMob.html(listItems);
		$statusToLocInputMob.selectize({
			onInitialize: function() {
				_self.wcag.selectizeInputAria($statusToLocInputMob[0].selectize);
			},
			onFocus: function() {
				$statusToLocMob.find('.booking-form--title').addClass('input-filled');
				$statusToLocMob.find('.selectize-control.single .selectize-input').addClass('select-filled');
				$statusToLocInput.parent().find('.selectize-control .selectize-input').removeClass('has-error');
				$statusToLocInput.parent().find('.booking-form--title').removeClass('has-error');
				let $toLocationChange = $statusToLocInputMob.find('option:selected').text();				
				if($toLocationChange !== '') {
					$statusToLocInputMob[0].selectize.clear();
					$("#fs-to-title").show();	
				}
			},
			onChange: function(value: any) {
				$statusToLocMob.find('.booking-form--title').addClass('input-filled');
				$statusToLocMob.find('.selectize-control.single .selectize-input').addClass('select-filled');
				if ($statusFromLocInputMob.val() === $statusToLocInputMob.val()) {
					$statusToLocInputMob.parent().find('.selectize-control .selectize-input').addClass('has-error');
					$statusToLocInputMob.parent().find('.booking-form--title').addClass('has-error');
				}
				else{
					$statusToLocInputMob.parent().find('.selectize-control .selectize-input').removeClass('has-error');
					$statusToLocInputMob.parent().find('.booking-form--title').removeClass('has-error');
				}
				let miniibeCTAbutton: string = $('#mini-ibe-cta-button').length? $('#mini-ibe-cta-button').val() : '';
				if (value.trim() !== "" && $('#members-travel--subsidy').length < 1 && miniibeCTAbutton ==''){
					$.magnificPopup.close();
				}
			},
			onBlur: function() {
				let $toLocationChangeMob = $statusToLocInputMob.find('option:selected').text();
				if ($toLocationChangeMob == '') {
					$statusToLocMob.find('.booking-form--title').removeClass('input-filled');
					$statusToLocMob.find('.selectize-control.single .selectize-input').removeClass('select-filled');
				} else {
					$statusToLocMob.find('.booking-form--title').addClass('input-filled');
					$statusToLocMob.find('.selectize-control.single .selectize-input').addClass('select-filled');
					let miniibeCTAbutton: string = $('#mini-ibe-cta-button').length? $('#mini-ibe-cta-button').val() : '';
					if($('#members-travel--subsidy').length < 1 && miniibeCTAbutton == '') {
						if ($.magnificPopup.instance.isOpen) {
							$.magnificPopup.close();
						}
					}	
				}
				$statusFromLocInputMob.attr('data-ibeclicked', 'true');
			},
			onLoad: function(data:any) {
				_self.fillToPrepopValue($statusToLocInputMob[0].selectize);
				//$statusToLocInputMob[0].selectize.trigger('blur');
			},
			lockOptgroupOrder: true,
			searchField: ['text'],
			selectOnTab: true,
			render: {
				item: function(item:any, escape:any) {					
					return '<div>' +
					(item.text ? '<span class = "airportname airportselected">' + escape(item.text.split('|')[0].split('__')[0]) + ' (' + escape(item.text.split('|')[2]) + ')</span>' : '') +
					'</div>';				
				},
				option: function(item:any, escape:any) {
					return '<div>' +
					(item.text ? '<p class = "airportline"><span class = "airportname">' + escape(item.text.split('|')[0].split('__')[0]) + '</span>' +'<span class = "airportcode">'+ escape(item.text.split('|')[2])+'</span></p><p>' + escape(item.text.split('|')[1]) + '</p>': '') +
					'</div>';
				}
			}
		});
		$("#fs-to-location-popup .status-to--location .selectize-input input").blur(function (e: any) {
			let miniibeCTAbutton: string = $('#mini-ibe-cta-button').length ? $('#mini-ibe-cta-button').val() : '';
			if ($('#members-travel--subsidy').length < 1 && miniibeCTAbutton == '') {
				e.preventDefault();
				$("#fs-to-location-popup .status-to--location .selectize-dropdown").show();
			}
		});

		$("#fs-to-location-popup .status-to--location .selectize-input input").focusout(function (e: any) {
			let miniibeCTAbutton: string = $('#mini-ibe-cta-button').length ? $('#mini-ibe-cta-button').val() : '';
			if ($('#members-travel--subsidy').length < 1 && miniibeCTAbutton == '') {
				e.preventDefault();
				$('#fs-to-location-popup .selectize-input')[0].focus();
			}
		});

		$("#fs-to-location-popup .status-to--location .selectize-input input").keyup(function(){ 
			
			if ($("#fs-to-location-popup .status-to--location .selectize-input input").val() === '') {
				$("#fs-to-title").show();
			} else {
				$("#fs-to-title").hide();
			}			
		});

	}

	/**
	 * pre-populate ibe on load with data attached via data-attributes
	 * for both desktop and mobile ibe
	 * @author dominic <dominic.gan@mirumagency.com>
	 *
	 * @param {ibeFlightStatusData} data
	 * @param {any}         instance
	 */
	populateOnload(data:ibeFlightStatusData, instance:any): void {
		let _self = this;
		console.log('pop fls', data, instance);

		// searchType
		switch (data.searchType) {
			case 'cities':
			case 'C':
				// cities
				let citiesLink:any = instance.find('a.status-cities');
				citiesLink.click();

				// toLoc
				if (data.toLoc !== undefined) {
					_self.toPrepop = data.toLoc;
					console.log(_self.toPrepop);
				}

				// fromLoc
				if (data.fromLoc !== undefined) {
					let fromLocationSel = instance.find('select.status-from--location')[0].selectize;
					fromLocationSel.setValue(data.fromLoc);
				}

				// flight date
				if (data.flightDate !== undefined && data.flightDate.length > 0) {
					let flightDateSel = instance.find('select.status-flight--date')[0].selectize;
					let parsedflightDateVal = moment(data.flightDate, 'YYYYMMDD').format('YYYY-MM-DD');
					flightDateSel.setValue(parsedflightDateVal);
				}

				break;
			case 'flight_no':
			case 'N':
				// flight no
				let flightNoLink:any = instance.find('a.status-flightno');
				flightNoLink.click();

				// flight no input
				let flightNoInput:any = instance.find('input.status-flight--no');
				if (data.flightNo !== undefined) {
					flightNoInput.val(data.flightNo);
					flightNoInput.blur();
				}

				// flight date
				if (data.flightDate !== undefined && data.flightDate.length > 0) {
					let flightDateSel = instance.find('select.status-flightno--date')[0].selectize;
					let parsedflightDateVal = moment(data.flightDate, 'YYYYMMDD').format('YYYY-MM-DD');
					flightDateSel.setValue(parsedflightDateVal);
				}
				break;
			default:
				break;
		}



	}

	/**
	 * fill prepop value to this select if waiting prepop value is present
	 */
	fillToPrepopValue(el:any):void {
		let _self = this;
		let val = _self.toPrepop;

		console.log(val);

		if (val) {
			console.log(el, val);
			el.setValue(val);
			_self.toPrepop = null;
		}
	}

	/**
	 * parse url params to detect flight status deep link
	 * open and populate with params
	 * ?ibe=fls&searchType=ABC&fromLoc=ABC&toLoc=ABC&flightNo=ABC&flightDate=ABC
	 */
	deeplink():void {
		let _self = this;
		let bcommon = _self.bcommon;

		let urlParams = bcommon.getUrlVars(window.location.href);

		if (urlParams.ibe && urlParams.ibe === 'fls') {

			// parse url params into ibeFlightStatusData object
			let flsData:ibeFlightStatusData = {};

			flsData.searchType = urlParams.searchType;
			flsData.fromLoc = urlParams.fromLoc;
			flsData.toLoc = urlParams.toLoc;
			flsData.flightNo = urlParams.flightNo;
			flsData.flightDate = urlParams.flightDate;

			const topNavIbe = $('.desktop#mab-bookingnav #flight-status--container');
			const mobNavIbe = $('.mobile#mab-bookingnav #mob-flightstatus--container');

			// expand desktop ibe
			if (!(/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))) {
				let $ibeNav:any = $('#bookingNav');
				$ibeNav.find('.flight-status').click();
				$ibeNav.find('.flight-status').parent().addClass('selected');
				topNavIbe.show();
				_self.populateOnload(flsData, topNavIbe);
			} else {
				// expand mobile ibe
				let $ibeNavList: any = $('#bookingNav li');
	      $ibeNavList.find('.mobile-flight-status').parent().addClass('selected');

	      mobNavIbe.show();
				_self.populateOnload(flsData, mobNavIbe);
			}
		}

	}


}

let scope:Element = document.querySelector('#flight-status--container');
if (scope){
	try {
		let _self = this;
		let flightstatusform = new flightStatusForm();
		let bookingformcommon = new bookingFormCommon();
		var adobeDataLayer = new adobeDataLayerWrapper();
		let wcag = new wcagOptions();
		flightstatusform.getThreeDays();
		flightstatusform.flightStatusCities();
		flightstatusform.flightStatusFlightNo();
		$.when(window['ibeOnDListNew']).done((listData: any) => {
			console.log('%cc005fstatus%c ond done', 'background-color: yellow', 'background-color: initial');
			// onload use revenue OnD
			let listItems:string = bookingformcommon.parseOnDListItemsNew(listData, 'redemption', 'flightstatus');

			flightstatusform.initSelectize(listItems);
			flightstatusform.nav();
			flightstatusform.deeplink();
		});
		flightstatusform.initTables();
	} catch(e) {console.error(e);}
}